import React from 'react';
import { Button, Modal, Badge, Alert } from 'react-bootstrap';
import './ScheduleModals.scss';

const TIME_OFF_REQUEST_TYPE_ID = 1;

const STATUS_VARIANTS = {
    pending: 'warning',
    approved: 'success',
    denied: 'danger',
};

const DAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const RequestDetailModal = ({ show, onHide, request, onEdit, onCancelRequest, submitting, submitError }) => {
    if (!request) return null;

    const isTimeOff = request.requestTypeID === TIME_OFF_REQUEST_TYPE_ID;

    const renderHours = () => {
        if (!request.days || request.days.length === 0) return '—';
        const sorted = request.days.slice().sort((a, b) => a.dayOfWeek - b.dayOfWeek);
        const allSame = sorted.every((d) => d.startTime === sorted[0].startTime && d.endTime === sorted[0].endTime);
        if (allSame) return `${sorted[0].startTime} – ${sorted[0].endTime}`;
        return sorted.map((d) => `${DAY_LABELS[d.dayOfWeek]?.slice(0, 3)}: ${d.startTime} – ${d.endTime}`).join(', ');
    };

    return (
        <Modal show={show} onHide={onHide} centered size={!isTimeOff ? 'lg' : undefined} className="schedule-modal">
            <Modal.Header closeButton>
                <Modal.Title>{isTimeOff ? 'Time Off' : 'Availability'} Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {submitError && <Alert variant="danger">{submitError}</Alert>}
                <div className="mb-2">
                    <strong>Status:</strong>{' '}
                    <Badge variant={STATUS_VARIANTS[request.status] || 'secondary'}>
                        {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                    </Badge>
                </div>
                {isTimeOff ? (
                    <>
                        <div className="mb-2">
                            <strong>Reason:</strong> {request.absenceType?.description || '—'}
                        </div>
                        <div className="mb-2">
                            <strong>Start Date:</strong> {request.startDate}
                        </div>
                        <div className="mb-2">
                            <strong>End Date:</strong> {request.endDate}
                        </div>
                        <div className="mb-2">
                            <strong>Partial Day:</strong>{' '}
                            {request.isPartialDay ? `${request.partialDayStart} – ${request.partialDayEnd}` : 'No'}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="mb-2">
                            <strong>Effective Range:</strong> {request.startDate} to {request.endDate}
                        </div>
                        <div className="mb-2">
                            <strong>Days:</strong>{' '}
                            {request.days && request.days.length > 0
                                ? request.days
                                      .slice()
                                      .sort((a, b) => a.dayOfWeek - b.dayOfWeek)
                                      .map((d) => DAY_LABELS[d.dayOfWeek]?.slice(0, 3))
                                      .join(', ')
                                : '—'}
                        </div>
                        <div className="mb-2">
                            <strong>Hours:</strong> {renderHours()}
                        </div>
                    </>
                )}
                <div className="mb-2">
                    <strong>Notes:</strong> {request.notes || '—'}
                </div>
                <div className="mb-2">
                    <strong>Reviewer Notes:</strong> {request.reviewerNotes || '—'}
                </div>
                <div className="mb-2">
                    <strong>Submitted:</strong> {new Date(request.createdAt).toLocaleDateString()}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {request.status === 'pending' && (
                    <>
                        <Button
                            variant="danger"
                            onClick={onCancelRequest}
                            disabled={submitting}
                            className="schedule-modal__btn"
                        >
                            Cancel Request
                        </Button>
                        <Button
                            variant="primary"
                            onClick={onEdit}
                            disabled={submitting}
                            className="schedule-modal__btn schedule-modal__btn--primary"
                        >
                            Edit
                        </Button>
                    </>
                )}
                <Button variant="secondary" onClick={onHide} className="schedule-modal__btn">
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RequestDetailModal;
